
import { Injectable } from '@angular/core';
import { CommonHeaderService } from './common-header.service';
import { Configuration, API_TYPES, HEADER, URL, COOKIES_CONSTANTS, API_ENDPOINT } from '@app/config';
import { SessionService } from '../services/session.service';
import { PrebidClient } from './prebid-client';

@Injectable()
export class ApiRequest {

    constructor(
        private prebidClient: PrebidClient,
        private commonHeaderService: CommonHeaderService,
        private sessionService: SessionService
    ) { }

    /**
     * method to get configuration of header and url
     *
     * @param {string} url
     * @param {API_TYPES} type
     * @param {boolean} [includeLangParam=false]
     * @param {boolean} [language=false]
     * @param {boolean} [isMultipartFileData=false]
     * @returns
     * @memberof ApiRequest
     */
    public getConfig(
        url: string,
        type: API_TYPES,
        includeLangParam: boolean = false,
        language: boolean = false,
        isMultipartFileData: boolean = false
    ) {

        const config: any = [];
        let header: any;
        switch (type) {
            case API_TYPES.PREBID:
                config[API_ENDPOINT] = this.prebidClient.getApiEndpoint();
                if (isMultipartFileData) {
                    header = this.commonHeaderService.getMultipartHeaders();
                } else {
                    header = this.prebidClient.getDefaultHeader();
                }
                break;

            default:
                if (isMultipartFileData) {
                    header = this.commonHeaderService.getMultipartHeaders();
                } else {
                    header = this.commonHeaderService.getDefaultHeaderRequestParams();
                }
                config[API_ENDPOINT] = Configuration.API_ENDPOINT;
                break;
        }

        config[HEADER] = header;

        if (language) {
            config[HEADER] = this.commonHeaderService.setLanguageParams(config.HEADER);
        }

        config[URL] = config[API_ENDPOINT] + (url.charAt(0) === '/' ? url.substring(1) : url);

        if (includeLangParam) {
            const d = new Date();
            const timestamp = d.getTime();
            config[URL] += '?lang=' + this.sessionService.getCookie(COOKIES_CONSTANTS.langCode) + '&timestamp=' + timestamp;
        }

        return config;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/http-client/api-request.ts